import { render, staticRenderFns } from "./_review2026.vue?vue&type=template&id=2e3ab064&scoped=true&lang=pug&"
import script from "./_review2026.vue?vue&type=script&lang=js&"
export * from "./_review2026.vue?vue&type=script&lang=js&"
import style0 from "./_review2026.vue?vue&type=style&index=0&id=2e3ab064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3ab064",
  null
  
)

export default component.exports